import React from 'react';
import { motion } from 'framer-motion';

const cases = [
  {
    title: "Project Alpha",
    situation: "Stalled logistics acquisition due to valuation disputes.",
    approach: "Restructured the narrative and financial presentation with earn-out modeling.",
    outcome: "Deal closed in 60 days at 15%+ valuation improvement.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=800&auto=format&fit=crop"
  },
  {
    title: "Project Horizon",
    situation: "Cross-border tech merger facing regulatory scrutiny.",
    approach: "Clean-room communication strategy and expert specialist navigation.",
    outcome: "Full regulatory clearance secured with zero operational lag.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=800&auto=format&fit=crop"
  },
  {
    title: "Project Legacy",
    situation: "Founder exit seeking premium positioning and liquidity.",
    approach: "Rapid operational audit and private buyer network activation.",
    outcome: "Successful cash exit via competing strategic bids.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800&auto=format&fit=crop"
  }
];

const Cases = () => {
  return (
    <section id="cases" className="py-24 md:py-32 bg-brand-navy text-brand-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Case Highlights</h2>
            <p className="text-brand-gold font-bold tracking-widest uppercase text-sm">Discretion is our Foundation</p>
          </div>
          <p className="max-w-md text-gray-400 font-light italic">
            "We protect the identity of our clients. These highlights represent the strategic outcomes achieved through our intervention."
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {cases.map((scenario, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="group"
            >
              <div className="mb-8 overflow-hidden aspect-video">
                <img 
                  src={scenario.image} 
                  alt={scenario.title} 
                  className="w-full h-full object-cover grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700" 
                />
              </div>
              <div className="space-y-6">
                <div>
                  <h4 className="text-xs font-bold tracking-widest text-brand-gold uppercase mb-2">Situation</h4>
                  <p className="text-gray-300 font-light">{scenario.situation}</p>
                </div>
                <div>
                  <h4 className="text-xs font-bold tracking-widest text-brand-gold uppercase mb-2">Approach</h4>
                  <p className="text-gray-300 font-light">{scenario.approach}</p>
                </div>
                <div className="pt-6 border-t border-white/10">
                  <h4 className="text-sm font-bold text-white uppercase mb-2">Outcome</h4>
                  <p className="text-white font-medium text-lg">{scenario.outcome}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cases;